import styled from 'styled-components'

export const GeneratedHTMLBarsContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
 

  .smusher {
    flex-grow: 1;
    height: 100%;
  }
    
  .end-cap {
    position: relative;
    height: 0;
    flex-grow: 0;
    width: 100%;

    .label {
      position: absolute;
    }

    &.start { 
      bottom: 100%;
    }

    &.end { 
      top: 100%;
    }

    
  }
 
  .bar-column {
    position: absolute;
    transform: translateX(-50%);
    bottom: 0;
    top: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;

    &.dual-axis {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: .25em;
    }
    .dual-axis-column {
      width: 100%;
      position: relative;
    }
  }     

  .bar-group-wrapper {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr auto;
  }

  .bar-group {
    position: relative;
    display: flex;
    justify-content: flex-end;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    min-height: 100%;
  }

  &:not(.vertical) {
    max-width: 45px;
    .bar {
      transition: height .4s .2s;

      &.is-not-filtered {
         
        order: 1;
      }
      &.is-filtered { 
        transition: height .2s .4s;
        height: 0!important; 
        order: 0;
      }
    }
  }


  &.vertical {
    align-items: center;
    justify-content: flex-start;
    max-height: 45px;
    .bar {
        min-width: 5px;
        transition: width .4s;
        &.is-not-filtered {
          transition: width .4s .2s;
          &:not(.is-selected) { order: 0; }
        }
        &.is-filtered { 
          min-width: 0;
          transition: width .2s;
          width: 0!important; 
          order: 1;
        }
      }
    .bar-column {
      transform: translateY(-50%);
      right: 0;
      left: 0;
    }

    
    .bar-group-wrapper {
      grid-template-rows: 1fr;
      grid-template-columns: auto 1fr auto;
      justify-content: flex-start;
    }

    .bar-group {
      position: relative;
      display: flex;
      justify-content: flex-start;
      display: flex;
      flex-direction: row;
      flex-grow: 1;
      min-width: 100%;
    }
      
  }

 
 
  .bar-column:not(.is-hovered) {
    .bar { 
      &.is-not-selected, &.is-filtered {
        background-color: lightgray!important;
        &:hover { background-color: inital; }
      }
    }
  }


  


  &.is-not-selected:not(:hover) { 
    background-color: lightgray!important;
  }
  
  
 
 
  .generator-tooltip-wrapper {
    top: 0;
    display: none;
    .tooltip__inner {
      transform: translate(-50%, -100%);
    }
  }

  &:hover { 
    .generator-tooltip-wrapper {
      display: block;
    }
  }
 
`